import { Button } from '@dnb/eufemia';
import { edit } from '@dnb/eufemia/icons';
import { ReactNode } from 'react';

import { SwitchContainerModeRef } from '@/types/SwitchContainerModeTypes';

interface FormEditButtonProps {
  switchContainerModeRef: SwitchContainerModeRef;
  disabled?: boolean;
  disabledTooltip?: string | ReactNode;
  onEdit?: () => void;
}

export function FormEditButton({ switchContainerModeRef, disabled, disabledTooltip, onEdit }: FormEditButtonProps) {
  const handleClick = () => {
    if (onEdit) {
      onEdit();
    }
    switchContainerModeRef.current?.('edit');
  };

  return (
    <Button
      disabled={disabled}
      icon={edit}
      icon_position="left"
      onClick={handleClick}
      tooltip={disabled ? disabledTooltip : undefined}
      variant="tertiary"
    >
      Edit
    </Button>
  );
}
